/**
 * One switch for every mock source behind the Gen AI dashboard.
 *
 * The dashboard grew three independent mock layers, and with them mixed the
 * screen lied: cards read 0 from the live API while the drill-down behind them
 * listed named employees and filenames out of a static file. This gathers them
 * so the dashboard is either wholly live or wholly mock, never a blend that
 * implies data nobody has.
 *
 *   1. `GEN_AI_MOCK`            — the dashboard cards (state.ts)
 *   2. `public/mock/gen-ai/*`   — the drill-down tables (package-data.ts)
 *   3. `gen_ai_gql`             — gql call mocks, already gated on env.mock
 *
 * Default is LIVE. Flip it for a demo from the console, no rebuild:
 *
 *   localStorage.setItem("cognni.genai.mock", "true")   // mock
 *   localStorage.removeItem("cognni.genai.mock")        // live
 */

const KEY = "cognni.genai.mock";

/** Mock is opt-in; anything the API cannot answer shows empty, not invented. */
const DEFAULT_TO_MOCK = false;

export const gen_ai_mock_enabled = (): boolean => {
  try {
    const stored = window.localStorage.getItem(KEY);
    if (stored !== null) return stored === "true";
  } catch {
    // private mode or storage disabled — fall through to the default
  }
  return DEFAULT_TO_MOCK;
};
